import { useCreateUTM, useGetUTM } from '@/shared/api'
import { UtmKey } from '@synapex/tools/utils'
import { useState } from 'react'

export type UseUtmArgs = {
    key: UtmKey
    site_id: number
    stateBy:
        | {
              type: 'id'
              selectedId: string
              onSelectedIdChange: (newSelectedId: string) => void
          }
        | {
              type: 'name'
              selectedName: string
              onSelectedNameChange: (selectedName: string) => void
          }
}
export const useUtmIdSelect = ({ key, site_id, stateBy }: UseUtmArgs) => {
    const query = useGetUTM(key, site_id)
    const mutate = useCreateUTM(key, site_id)
    const [newNameInput, setNewNameInput] = useState('')

    const { value, onChange } = (() => {
        if (stateBy.type === 'id') {
            return {
                value: stateBy.selectedId,
                onChange: stateBy.onSelectedIdChange,
            }
        } else {
            // console.log({ stateBy, data: query.data })
            const selectedId =
                query.data?.find((item) => item.name === stateBy.selectedName)
                    ?.id ?? ''

            return {
                value: selectedId,
                onChange: (id: string) => {
                    //new id selected - get its name
                    const name =
                        query.data?.find((item) => item.id === id)?.name ?? ''
                    stateBy.onSelectedNameChange(name)
                },
            }
        }
    })()

    return {
        key,
        value,
        onChange,
        query,
        newNameInput,
        setNewNameInput,
        create: async () => {
            await mutate.mutateAsync(
                {
                    name: newNameInput,
                    site_id,
                },
                {
                    onSettled: (data, error) => {
                        if (error) {
                            console.error(error)
                        }

                        if (data) {
                            onChange(data.id)
                            setNewNameInput('')
                        }
                    },
                }
            )
        },
    }
}
